import type { Store } from 'effector'

import { useUnit } from 'effector-react'
import { useEffect, useState } from 'react'

export function useSubmitLocked(
  $pending: Store<unknown>,
  $error: Store<unknown>
) {
  const hasError = useUnit($error)
  const isPending = useUnit($pending)
  const [isSubmitLocked, setIsSubmitLocked] = useState(false)

  useEffect(() => {
    if (isPending) setIsSubmitLocked(true)
    if (hasError) setIsSubmitLocked(false)
  }, [isPending, hasError])

  return isSubmitLocked
}
